var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPhoneIcon = function SvgPhoneIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.69816 2.24805C9.15873 2.08654 8.58937 2.00002 8.00008 2.00002V0.666687C8.72074 0.666687 9.41887 0.772613 10.0806 0.970742C12.6224 1.73178 14.6022 3.84227 15.3108 6.4946L14.0227 6.83877C13.4263 4.60665 11.7705 2.86852 9.69816 2.24805ZM7.03039 4.72729L4.30311 2.00002L0.666748 5.63638L10.3637 15.3334L14.0001 11.697L11.2728 8.96972L10.3637 9.87881L6.12129 5.63638L7.03039 4.72729ZM5.14477 4.72729L4.30311 3.88564L2.55237 5.63638L10.3637 13.4477L12.1145 11.697L11.2728 10.8553L10.3637 11.7644L4.23568 5.63638L5.14477 4.72729ZM8.00008 4.66669C8.32455 4.66669 8.63792 4.71627 8.93517 4.80898C10.0767 5.16502 11.0142 6.17311 11.3543 7.49899L12.6458 7.16772C12.2029 5.44081 10.9591 4.04352 9.33215 3.53612C8.9087 3.40405 8.46158 3.33335 8.00008 3.33335V4.66669Z",
    fill: "#220C4A"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPhoneIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/phone-icon.ac1a472f.svg";
export { ForwardRef as ReactComponent };